export default "__VITE_PUBLIC_ASSET__ed37bce0__"